import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Combobox from "../../components/Combobox";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Breadcrumb from "../../components/Breadcrumb";
import Button from "../../components/Button";
import { Mail, Mails, X } from "lucide-react";
import { useDeviceLayout } from "../../components/DeviceLayoutProvider";

const RowPCC = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div className="grid grid-cols-4 py-4 ml-5 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Codice}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Descrizione}
                </div>
                <div className="flex items-center pl-2 " style={{ color: data.value.ColoreStato || 'inherit' }}>
                    {data.value.StatoAttuale}
                </div>
                <div className={`flex items-center pl-2 ${data.value.StatoAttuale === "In Scadenza" ? "text-orange-600" : data.value.StatoAttuale === "Scaduto" ? "text-red-600" : null}`}>
                    {data.value.ProssimaManutenzione}
                </div>
            </div>
        </div>
    );
};
const RowPCA = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div className="grid grid-cols-3 py-4 ml-5 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Email}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.CC}
                </div>
            </div>
        </div>
    );
};
const RowPCIC = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div className="grid grid-cols-3 py-4 ml-5 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Descrizione}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.CC}
                </div>
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className={`ml-1 text-sm`} style={header.key === "StatoAttuale" ? { color: data.value.ColoreStato || 'inherit' } : {}}>
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Dash = () => {
    const [dataRow, setDataRow] = useState({});
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [isMailVisible, setIsMailVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [utenti, setUtenti] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });
    const [dataAziende, setDataAziende] = useState([]);
    const [azienda, setAzienda] = useState({ value: {}, index: null });
    const [dataImpianti, setDataImpianti] = useState([]);
    const [impianto, setImpianto] = useState({ value: {}, index: null });
    const [dataCategorie, setDataCategorie] = useState([]);
    const [categoria, setCategoria] = useState({ value: {}, index: null });
    const [componenti, setComponenti] = useState([]);
    const [dataComponenti, setDataComponenti] = useState([]);
    const [stage, setStage] = useState(0);
    const [macro, setMacro] = useState([]);
    const [selectedMacro, setSelectedMacro] = useState(null);
    const { isLittle } = useDeviceLayout();

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (isMailVisible) {
            const loadUtenti = async () => {
                setIsLoading(true);
                try {
                    const r = await fetch("/getUtentiByGestione", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"],
                            IDAzienda: dataRow.value["IDAzienda"]
                        }),
                    });

                    const rd = await r.json();

                    if (r.status === 500) {
                        console.log(rd.error);
                        setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                        setShowAlert(true);
                        setIsMailVisible(false);
                    } else {
                        setUtenti(rd.filter((d) => d["DataEliminazione"] === null));
                    }
                } catch (error) {
                    console.log(error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento degli utenti, riprova più tardi", onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setIsMailVisible(false);
                }
                setIsLoading(false);
            };
            loadUtenti();
        }
    }, [isMailVisible]);

    const onload = async () => {
        setIsLoading(true);
        await loadNav();
        try {
            const r1 = await fetch("/getScadenze", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] })
            });

            const rd1 = await r1.json();

            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                setShowAlert(true);
            }
            else {

                if (rd1.length === 0) {
                    setAlertInfo({ type: "info", text: "Non ci sono articoli in scadenza", onClose: () => { setShowAlert(false);}, needConfirm: false });
                    setShowAlert(true);
                    setIsLoading(false);
                    return;
                }

                const distinctAziende = [...new Set(rd1.map(i => i.IDAzienda))];
                const distinctImpianti = [...new Set(rd1.map(i => i.IDImpianto))];
                const distinctCategorie = [...new Set(rd1.map(i => i.IDCategoria))];
                const distinctComponenti = [...new Set(rd1.map(i => i.ID))];

                const r2 = await fetch("/getAziendeScadenze", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], Aziende: distinctAziende })
                });
                const rd2 = await r2.json();
                if (r2.status === 500) {
                    console.log(rd2.error);
                    setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setDataAziende(rd2.map(item => ({ value: item[0] })));

                    const r3 = await fetch("/getImpiantiScadenze", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], Impianti: distinctImpianti })
                    });
                    const rd3 = await r3.json();
                    if (r3.status === 500) {
                        console.log(rd3.error);
                        setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        setDataImpianti(rd3.map(item => ({ value: item[0] })));

                        const r4 = await fetch("/getCategorieScadenze", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], Categorie: distinctCategorie })
                        });
                        const rd4 = await r4.json();
                        if (r4.status === 500) {
                            console.log(rd4.error);
                            setAlertInfo({ type: "error", text: rd4.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                            setShowAlert(true);
                        } else {
                            setDataCategorie(rd4.map(item => ({ value: item[0] })));

                            const r6 = await fetch("/getCategorie", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
                            });

                            const rd6 = await r6.json();

                            if (r6.status === 500) {
                                setAlertInfo({ type: "error", text: rd6.error, onClose: () => { setShowAlert(false); navigate("/manager/dash"); }, needConfirm: false });
                                setShowAlert(true);
                            } else {
                                setMacro(rd6.filter(d => d.IDPadre === null));
                            }

                            const r5 = await fetch("/getComponentiScadenze", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], Componenti: distinctComponenti })
                            });
                            const rd5 = await r5.json();
                            if (r5.status === 500) {
                                console.log(rd5.error);
                                setAlertInfo({ type: "error", text: rd5.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                                setShowAlert(true);
                            } else {
                                setComponenti(rd5.map(item => ({ value: item[0], checked: false })));
                            }
                        }
                    }

                }
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei componenti, riprova più tardi", onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const sendNotifyToAll = async () => {
        setIsLoading(true);
        try {
            const response = await fetch("/sendAllManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] })
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            } else {
                setAlertInfo({ type: "success", text: "Mail inviata con successo a tutti gli utenti", onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'invio della mail, riprova più tardi", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const addUser = (IDUtente) => {
        if (selectedUsers.includes(utenti.find((d) => d["ID"] === Number(IDUtente)))) {
            setAlertInfo({ type: "info", text: "Utente già selezionato", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
        setSelectedUsers([...selectedUsers, utenti.find((d) => d["ID"] === Number(IDUtente))]);
    };

    const handleRimuoviUtente = (ID) => {
        setSelectedUsers(selectedUsers.filter((d) => d["ID"] !== Number(ID)));
    };

    const handleSendAll = async () => {
        setIsLoading(true);
        try {
            const r = await fetch("/sendManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Utenti: utenti,
                    Componente: dataRow.value
                })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setIsMailVisible(false);
            }
            else {
                setIsLoading(false);
                setAlertInfo({ type: "success", text: "Mail inviata con successo a tutti gli utenti", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'invio della mail, riprova più tardi", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
            setShowAlert(true);
            setIsMailVisible(false);
        }
    };

    const handleSend = async () => {
        setIsLoading(true);
        try {
            const r = await fetch("/sendManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Utenti: selectedUsers,
                    Componente: dataRow.value
                })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setIsMailVisible(false);
            } else {
                setAlertInfo({ type: "success", text: "Mail inviata con successo", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'invio della mail, riprova più tardi", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"DASHBOARD"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <div className="flex justify-center items-center py-1 font-semibold w-full mt-2">SCADENZE</div>
                {
                    isLittle ? (
                        <>
                            <Breadcrumb
                                locations={[azienda.value?.["Nome"] || "CLIENTE", impianto.value["Nome"] || "SITO", categoria.value["Nome"] || "CATEGORIA", "COMPONENTI"].slice(0, stage + 1)}
                                currentLocation={stage}
                                onChange={(index) => {
                                    setStage(index);
                                    if (index === 0) {
                                        setAzienda({ value: {}, index: null });
                                        setImpianto({ value: {}, index: null });
                                        setCategoria({ value: {}, index: null });
                                        setSelectedMacro(null);
                                        setDataComponenti([]);
                                    }
                                    if (index === 1) {
                                        setImpianto({ value: {}, index: null });
                                        setCategoria({ value: {}, index: null });
                                        setSelectedMacro(null);
                                        setDataComponenti([]);
                                    }
                                    if (index === 2) {
                                        setSelectedMacro(null);
                                        setCategoria({ value: {}, index: null });
                                        setDataComponenti([]);
                                    }
                                }}
                            />
                            {stage === 0 && (
                                <Table
                                    headers={[
                                        { label: 'Nome', key: 'Nome' },
                                        { label: 'Email', key: 'Email' },
                                        { label: 'N. Articoli In Scadenza', key: 'CC' }
                                    ]}
                                    keyForPreview={["Nome", "Email", "CC"]}
                                    data={dataAziende}
                                    setData={setDataAziende}
                                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCA data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                    itemsPC={9}
                                    itemsMobile={8}
                                    needResearch={true}
                                    clickableRow={true}
                                    actionRow={(row, rowIndex) => { setStage(1); setAzienda({ value: row.value, index: rowIndex }) }}
                                    classes="mt-1"
                                />
                            )}
                            {stage === 1 && (
                                <Table
                                    headers={[
                                        { label: 'Nome', key: 'Nome' },
                                        { label: 'Descrizione', key: 'Descrizione' },
                                        { label: 'N. Articoli In Scadenza', key: 'CC' }
                                    ]}
                                    keyForPreview={["Nome", "Descrizione", "CC"]}
                                    data={dataImpianti.filter((d) => d.value["IDAzienda"] === azienda.value["ID"])}
                                    setData={setDataImpianti}
                                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCIC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                    itemsPC={9}
                                    itemsMobile={8}
                                    needResearch={true}
                                    clickableRow={true}
                                    actionRow={(row, rowIndex) => { setImpianto({ value: row.value, index: rowIndex }); setStage(2); setSelectedMacro(null); }}
                                    classes="mt-1"
                                />
                            )}
                            {stage === 2 && (
                                <>
                                    <div className="flex justify-center items-center w-full mt-3">
                                        <Combobox
                                            label="Macro Categoria"
                                            options={macro.filter(d => componenti.some(c => c.value["IDImpianto"] === impianto.value["ID"] && d["ID"] === dataCategorie.find(dc => dc.value["ID"] === c.value["IDCategoria"])?.value["IDPadre"])).map((d) => ({ label: d["Nome"], value: d["ID"] }))}
                                            onChange={(value) => { setSelectedMacro(value); setCategoria({ value: {}, index: null }); setDataComponenti([]); }}
                                            classes='w-full'
                                            defaultValue={selectedMacro}
                                        />
                                    </div>
                                    {selectedMacro && (
                                        <Table
                                            headers={[
                                                { label: 'Nome', key: 'Nome' },
                                                { label: 'Descrizione', key: 'Descrizione' },
                                                { label: 'N. Articoli In Scadenza', key: 'CC' }
                                            ]}
                                            keyForPreview={["Nome", "Descrizione", "CC"]}
                                            data={dataCategorie.filter(d => d.value["IDPadre"] === Number(selectedMacro) && componenti.some(c => c.value["IDCategoria"] === d.value["ID"] && c.value["IDAzienda"] === azienda.value["ID"] && c.value["IDImpianto"] === impianto.value["ID"]))}
                                            setData={setDataCategorie}
                                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCIC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                            itemsPC={9}
                                            itemsMobile={8}
                                            needResearch={true}
                                            clickableRow={true}
                                            actionRow={(row, rowIndex) => { setCategoria({ value: row.value, index: rowIndex }); setStage(3); setDataComponenti(componenti.filter((d) => d.value["IDAzienda"] === azienda.value["ID"] && d.value["IDImpianto"] === impianto.value["ID"] && d.value["IDCategoria"] === row.value["ID"])) }}
                                            classes="mt-2"
                                        />
                                    )}
                                </>
                            )}
                            {stage === 3 && (
                                <Table
                                    headers={[
                                        { label: 'Codice', key: 'Codice' },
                                        { label: 'Descrizione', key: 'Descrizione' },
                                        { label: 'Stato Attuale', key: 'StatoAttuale' },
                                        { label: 'Prossima Manutenzione', key: 'ProssimaManutenzione' },
                                    ]}
                                    keyForPreview={["Codice", "ProssimaManutenzione"]}
                                    data={dataComponenti}
                                    setData={setDataComponenti}
                                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                    itemsPC={9}
                                    itemsMobile={8}
                                    needResearch={true}
                                    clickableRow={true}
                                    actionRow={(row, rowIndex) => { setDataRow(row); setIsRowInfoVisible(true); }}
                                    classes="mt-1"
                                    needCheckbox={true}
                                    viewCheckboxMobile={false}
                                    renderButtonForCheckbox={() =>
                                        <Button type="hollow" onClick={sendNotifyToAll}>
                                            MAIL A TUTTI <Mails size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                    }
                                />
                            )}
                        </>
                    ) : (
                        <div className="flex flex-row w-full">
                            <div className={`${stage === 0 ? 'w-full' : stage > 0 && 'w-[20%] mr-2'}`}>
                                {
                                    stage > 0 && (
                                        <div className="flex justify-center items-center py-1 font-semibold w-full">CLIENTE</div>
                                    )
                                }
                                <Table
                                    headers={[
                                        { label: 'Nome', key: 'Nome' },
                                        { label: 'Email', key: 'Email' },
                                        { label: 'N. Articoli In Scadenza', key: 'CC' }
                                    ]}
                                    keyForPreview={["Nome", "Email"]}
                                    data={dataAziende}
                                    setData={setDataAziende}
                                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCA data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                    itemsPC={9}
                                    itemsMobile={5}
                                    needResearch={stage === 0}
                                    clickableRow={true}
                                    actionRow={(row, rowIndex) => { setStage(1); setAzienda({ value: row.value, index: rowIndex }) }}
                                    classes="mt-1"
                                    forceSmall={stage > 0}
                                    forceXS={stage > 0}
                                    needSortForSmall={false}
                                    needOnlyPreviewSmall={true}
                                    needSelectedGlowing={true}
                                    rowIndexSelected={azienda.index}
                                />
                            </div>
                            {stage >= 1 && (
                                <div className={`${stage === 1 ? 'w-full' : stage > 1 && 'w-[20%] mr-2'}`}>
                                    {
                                        stage > 1 && (
                                            <div className="flex justify-center items-center py-1 font-semibold w-full">SITO</div>
                                        )
                                    }
                                    <Table
                                        headers={[
                                            { label: 'Nome', key: 'Nome' },
                                            { label: 'Descrizione', key: 'Descrizione' },
                                            { label: 'N. Articoli In Scadenza', key: 'CC' }
                                        ]}
                                        keyForPreview={["Nome", "Descrizione"]}
                                        data={dataImpianti.filter((d) => d.value["IDAzienda"] === azienda.value["ID"])}
                                        setData={setDataImpianti}
                                        renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCIC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                        renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                        itemsPC={9}
                                        itemsMobile={5}
                                        needResearch={stage === 1}
                                        clickableRow={true}
                                        actionRow={(row, rowIndex) => { setImpianto({ value: row.value, index: rowIndex }); setStage(2); setSelectedMacro(null); }}
                                        classes="mt-1"
                                        forceSmall={stage > 1}
                                        forceXS={stage > 1}
                                        needSortForSmall={false}
                                        needOnlyPreviewSmall={true}
                                        needSelectedGlowing={true}
                                        rowIndexSelected={impianto.index}
                                    />
                                </div>
                            )}
                            {stage >= 2 && (
                                <div className={`${stage === 2 ? 'w-full' : stage > 2 && 'w-[20%] mr-2'}`}>
                                    {
                                        stage > 2 && (
                                            <div className="flex justify-center items-center py-1 font-semibold w-full">CATEGORIA</div>
                                        )
                                    }
                                    <div className="flex justify-center items-center w-full">
                                        <Combobox
                                            label="Macro Categoria"
                                            options={macro.filter(d => componenti.some(c => c.value["IDImpianto"] === impianto.value["ID"] && d["ID"] === dataCategorie.find(dc => dc.value["ID"] === c.value["IDCategoria"])?.value["IDPadre"])).map((d) => ({ label: d["Nome"], value: d["ID"] }))}
                                            onChange={(value) => { setSelectedMacro(value); setCategoria({ value: {}, index: null }); setDataComponenti([]); }}
                                            classes={`${stage > 2 ? 'mt-1 w-full' : 'w-[50%]'}`}
                                            defaultValue={selectedMacro}
                                        />
                                    </div>
                                    {selectedMacro && (
                                        <Table
                                            headers={[
                                                { label: 'Nome', key: 'Nome' },
                                                { label: 'Descrizione', key: 'Descrizione' },
                                                { label: 'N. Articoli In Scadenza', key: 'CC' }
                                            ]}
                                            keyForPreview={["Nome", "Descrizione"]}
                                            data={dataCategorie.filter(d => d.value["IDPadre"] === Number(selectedMacro) && componenti.some(c => c.value["IDCategoria"] === d.value["ID"] && c.value["IDAzienda"] === azienda.value["ID"] && c.value["IDImpianto"] === impianto.value["ID"]))}
                                            setData={setDataCategorie}
                                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCIC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                            itemsPC={9}
                                            itemsMobile={5}
                                            needResearch={stage === 2}
                                            clickableRow={true}
                                            actionRow={(row, rowIndex) => { setCategoria({ value: row.value, index: rowIndex }); setStage(3); setDataComponenti(componenti.filter((d) => d.value["IDAzienda"] === azienda.value["ID"] && d.value["IDImpianto"] === impianto.value["ID"] && d.value["IDCategoria"] === row.value["ID"])) }}
                                            classes="mt-1"
                                            forceSmall={stage > 2}
                                            forceXS={stage > 2}
                                            needSortForSmall={false}
                                            needOnlyPreviewSmall={true}
                                            needSelectedGlowing={true}
                                            rowIndexSelected={categoria.index}
                                        />
                                    )}
                                </div>
                            )}
                            {stage >= 3 && (
                                <div className={'w-full'}>
                                    <Table
                                        headers={[
                                            { label: 'Codice', key: 'Codice' },
                                            { label: 'Descrizione', key: 'Descrizione' },
                                            { label: 'Stato Attuale', key: 'StatoAttuale' },
                                            { label: 'Prossima Manutenzione', key: 'ProssimaManutenzione' },
                                        ]}
                                        keyForPreview={["Codice", "Descrizione"]}
                                        data={dataComponenti}
                                        setData={setDataComponenti}
                                        renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                        renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                        itemsPC={9}
                                        itemsMobile={5}
                                        needResearch={true}
                                        clickableRow={true}
                                        actionRow={(row, rowIndex) => { setDataRow(row); setIsRowInfoVisible(true); }}
                                        classes="mt-1"
                                        needCheckbox={true}
                                        viewCheckboxMobile={false}
                                        renderButtonForCheckbox={() =>
                                            <Button type="hollow" onClick={sendNotifyToAll}>
                                                MAIL A TUTTI <Mails size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    )
                }

                <PopUp title={""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={false}
                >
                    <>
                        <div className="flex justify-center items-center">
                            <Button type="hollow" onClick={() => { setIsMailVisible(true) }}>
                                INVIA EMAIL<Mail size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </div>

                    </>

                </PopUp >
                <PopUp title={"Mail di notifica"}
                    isVisible={isMailVisible}
                    setIsVisible={() => { setIsMailVisible(false); setSelectedUsers([]); setUtenti([]); }}
                    needConfirm={false}
                >
                    <>
                        <div className="flex flex-col justify-center items-center mt-4">
                            <Button type="hollow" classes="w-[80%] md:w-[70%]" onClick={handleSendAll}>
                                INVIA A TUTTI GLI UTENTI
                            </Button>
                            <div className="relative flex items-center justify-center w-full mt-4">
                                <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                                <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure</span>
                            </div>
                            <Combobox
                                label="Aggiungi Utente"
                                options={utenti.map((d) => ({ label: `${d["Nome"]} ${d["Cognome"]}`, value: d["ID"] }))}
                                onChange={(value) => { addUser(value) }}
                                classes="w-[80%] md:w-[70%] mt-2"
                            />
                            <div className="mt-3 flex flex-col gap-1 w-full">
                                {
                                    selectedUsers.map((user) => (
                                        <div key={user["ID"]} className="flex items-center justify-between bg-gray-200 dark:bg-neutral-800 rounded-lg px-4 py-2">
                                            <span>{`${user["Nome"]} ${user["Cognome"]}`}</span>
                                            <X size={20} strokeWidth={2} className="inline-block hover:cursor-pointer text-red-600 " onClick={() => { handleRimuoviUtente(user["ID"]) }} />
                                        </div>
                                    ))
                                }
                            </div>
                            {
                                selectedUsers.length > 0 && (
                                    <Button type="hollow" classes="w-[80%] md:w-[70%] mt-4" onClick={handleSend}>
                                        INVIA
                                    </Button>
                                )
                            }
                        </div>
                    </>

                </PopUp >
            </div >
        </div >
    )
};

export default Dash;